import React, { useEffect, useState } from "react";
import MobileMenuSearch from "./sub-components/MobileMenuSearch";
import MobileNavMenu from "./sub-components/MobileNavMenu";
import {
    connect
} from "react-redux";
import {
    multilanguage
} from "redux-multilanguage";
import {
    globalURL
} from "../../../../constants";

const MobileMenu = ({ login, shopPage, strings, currentLanguageCode }) => {
    const [searchInput, setValue] = useState("");
    const [searchResult, setSearchResult] = useState([]);
    useEffect(() => {
        const offCanvasNav = document.querySelector("#offcanvas-navigation");
        const offCanvasNavSubMenu = offCanvasNav.querySelectorAll(".sub-menu");
        const anchorLinks = offCanvasNav.querySelectorAll("a");

        for (let i = 0; i < offCanvasNavSubMenu.length; i++) {
            offCanvasNavSubMenu[i].insertAdjacentHTML(
                "beforebegin",
                "<span class='menu-expand'><i></i></span>"
            );
        }

        const menuExpand = offCanvasNav.querySelectorAll(".menu-expand");
        const numMenuExpand = menuExpand.length;

        for (let i = 0; i < numMenuExpand; i++) {
            menuExpand[i].addEventListener("click", e => {
                sideMenuExpand(e);
            });
        }

        for (let i = 0; i < anchorLinks.length; i++) {
            anchorLinks[i].addEventListener("click", () => {
                closeMobileMenu();
            });
        }
    });

    const search = (search) => {
        if (search.trim().length > 2) {
            let queryResultProduct = shopPage.products.filter(product =>
                String(product.product.productName[currentLanguageCode]).toLocaleLowerCase(currentLanguageCode).includes(String(search).trim().toLocaleLowerCase(currentLanguageCode)));
            let queryResultColor = shopPage.products.filter(product =>
                String(product.color.colorName).toLocaleLowerCase(currentLanguageCode).includes(String(search).trim().toLocaleLowerCase(currentLanguageCode)));
            setSearchResult([...queryResultProduct, ...queryResultColor]);
        } else {
            setSearchResult([]);
        }
    }

    const sideMenuExpand = e => {
        e.currentTarget.parentElement.classList.toggle("active");
    };

    const closeMobileMenu = () => {
        const offcanvasMobileMenu = document.querySelector(
            "#offcanvas-mobile-menu"
        );
        offcanvasMobileMenu.classList.remove("active");
        setSearchResult([]);
        setValue("");
    };

    return (
        <div className="offcanvas-mobile-menu" id="offcanvas-mobile-menu">
            <button
                className="offcanvas-menu-close"
                id="mobile-menu-close-trigger"
                onClick={() => closeMobileMenu()}
            >
                <i className="pe-7s-close"></i>
            </button>
            <div className="offcanvas-wrapper">
                <div className="offcanvas-inner-content">
                    <div className="offcanvas-mobile-search-area">
                        <input onChange={(e) => setValue(e.target.value)} value={searchInput} onKeyUp={(e) => search(e.target.value)} type="search" placeholder={strings['product']['search']} />
                        <button type="submit">
                            <i className="fa fa-search" />
                        </button>
                    </div>

                    <div style={{ display: "flex", flexWrap: "wrap" }}>
                        {
                            searchResult.map((item, i) => {
                                return <a href={process.env.PUBLIC_URL + "/product/" + item.product.seoName + "/" + item.color.colorCode} style={{ margin: "10px 10px 0px 0" }} key={i}>
                                    <img
                                        style={{ width: 70 }}
                                        className="default-img"
                                        src={globalURL + "/images/" + item.images[0].name}
                                        alt={item.product.seoName}
                                    />
                                </a>


                            })
                        }
                    </div>
                    <MobileNavMenu display={searchResult.length > 0 ? "none" : "block"} user={login.user} products={shopPage.uniqueProducts} categories={shopPage.categories} />
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = state => {
    return {
        login: state.login,
        shopPage: state.shopPage
    };
};


export default connect(mapStateToProps, {
})(multilanguage(MobileMenu));